import * as React from "react";
import { usePrescriptionFormLayout } from "../../../../context/steps/PrescriptionFormStep/context/PrescriptionFormLayoutContext.js";
import { calculateLineWrap } from "../../../../utils/steps/PrescriptionFormStep/utils/calculate-line-wrap.js";
const usePrescriptionFormLabelWrap = ({ labelRef, side }) => {
  const { setLabelAmountOfLines, availableLabelWidth } = usePrescriptionFormLayout();
  React.useLayoutEffect(() => {
    if (side === "right" && labelRef.current) {
      requestAnimationFrame(() => {
        const label = labelRef.current;
        if (label) {
          const simulatedLabel = label.cloneNode(true);
          const width = Math.max(0, availableLabelWidth);
          simulatedLabel.style.width = `${width}px`;
          simulatedLabel.id = "";
          simulatedLabel.style.visibility = "hidden";
          document.body.appendChild(simulatedLabel);
          const numberOfLines = calculateLineWrap(simulatedLabel);
          setLabelAmountOfLines((prev) => ({
            ...prev,
            [label.id]: numberOfLines
          }));
          document.body.removeChild(simulatedLabel);
        }
      });
    }
  }, [side, labelRef, availableLabelWidth, setLabelAmountOfLines]);
};
export {
  usePrescriptionFormLabelWrap
};
//# sourceMappingURL=use-prescription-form-label-wrap.js.map
